import { flexWorkerService } from 'hq/services';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetFlexWorkerSchedule = (flexWorkerId: string) => {
  const queryFn = async () => await flexWorkerService.getFlexWorkerSchedule(flexWorkerId);

  return useQuery(QUERY_KEYS.flexWorkerSchedule(flexWorkerId), queryFn);
};
